let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8izot")).then(() => parcelRequire('hQ425'));